import Api from "./Api";
import store from "../state/store";

export default {
  getCurrentLanguage(){
    return store.getters["i18N/getLanguage"]
    },
  userDetails() {
    return Api().get(`/user_details`);
  },
  getUser(id) {
    return Api().get(`/user/${id}`);
  },
  getAll(params) {
    return Api().get(`/users/${store.getters["authfack/currentEntity"].id}`, {
      params: {
        filterBy:
          Object.keys(store.getters["grid/getFilterValues"]).length > 0
            ? store.getters["grid/getFilterValues"]
            : {},
        orderBy:
          params && params.orderBy
            ? params && params.orderBy
            : { sortField: null },
        limit: params && params.limit ? params && params.limit : 1,
        page: store.getters["grid/getCurrentPage"],
      },
    });
  },
  createUser(params) {
    return Api().post("/users", params);
  },
  updateUser(params) {
    return Api().post(`/users/update/${params.id}`, params.user);
  },
  addUserWalkin(params) {
    return Api().post(`/update-user-details`, params.user);
  },
  moveUser(params) {
    return Api().put(`/users_usertype`, params);
  },
  deleteUser(id) {
    return Api().delete(`/users/${id}`, {
      params: {
        entity_id: store.getters["authfack/currentEntity"].id,
      },
    });
  },
  denyUser(params) {
    return Api().put(`/users_active`, params);
  },
  importUsers(params) {
    return Api().post("/api/users/import", params);
  },
  // roles
  getuserRoles() {
    return Api().get(`/roles/${store.getters["authfack/currentEntity"].id}`);
  },
  // departments
  getDepartments() {
    return Api().get(
      `/department/${store.getters["authfack/currentEntity"].id}`
    );
  },
  // duplicated users 
  getDuplicatedUsers(params) {
    return Api().get(
      `/get_users_duplicate/${store.getters["authfack/currentEntity"].id}`,
      {
        params: { filterBy: params && params.filterBy ? params.filterBy : {} }
      }
    );
  },
  mergeDuplicatedUser(params) {
    return Api().post(`/merge_user`, params);
  },
  generateFaceIDforDuplicatedUser(params) {
    return Api().post(`/generate_faceId`, params);
  },
  // invite and invoke user 
  inviteInvokeUser(params) {
    return Api().put(`/invite_revoke`, params);
  },
  // document
  createDocument(params) {
    return Api().post(`/user_document`, params);
  },
  getDocuments() {
    return Api().get(
      `/get_type_for_user_document/${store.getters["authfack/currentEntity"].id}`
    );
  },
  // vaccine details
  userDocumentStatus(params) {
    return Api().put(`/user_document/${params.id}`, { status: params.status });
  },
  inviteMultipleUsers(params) {
    return Api().get("/mass-action-invite-users", { params: { users: params } })
  },
  massactionApplyInviteUsers(params) {
    return Api().post("/mass-action-apply-invite-users", { users: [params] })
  },
  massactionRevokeFromDashboard(params) {
    return Api().post("/mass-action-apply-revoke-users", { users: params })
  },
  getUserResources(params) {
    return Api().get("/user_resources", { params: params })
  },
  getSitesAndUserTypesWithPermissions(params) {
    return Api().get("/user_resources_within_permissions", { params: params })
  },
  updateUserResource(params) {
    return Api().put("/user_resource", { data: params })
  },
  massactionRfidEnrollment(params) {
    return Api().get("/get_users_have_rfid_enrollment", { params: { entityId: params.entityId, userIds: params.usersIds } })
  },
  getLastVisitForUser(params) {
    return Api().get("/last-visits/signedin", params );
  },
  addLabel(data) {
    return Api().post("/label", data);
  },

  addLabelsMultiple(data) {
    return Api().post("/mass_action_apply_labels", data);
  },
  getLabels(id) {
    return Api().get(`/labels/${id}`,);
  },
  checkUniqueSection(data) {
    let url = `/sections/unique?entity_id=${store.getters["authfack/currentEntity"].id}&value=${data.value}`;
    if (data.section_id) url += `&section_id=${data.section_id}`;
    return Api().get(url, data);
  },
  getSections() {
    return Api().get('/section/with_custom_field');
  },
  getSection(id) {
    return Api().get(`/sections/${id}`);
  },
  addSection(data) {
    return Api().post("/section", data);
  },
  editSection(data) {
    return Api().put(`/section/${data.id}`, data.form);
  },
  deleteSection(id) {
    return Api().delete(`/section/delete_with_custom_field/${id}`);
  },
  checkIfUserExists(email, phone) {
    return Api().post(`/check_user_found/${this.getCurrentLanguage()}`, {
        email,
        phone,
        entity_id: store.getters["userType/getPreRegEntityDetails"].id
    })
  },
  getExpectedVisitCustomFields(payload){
    return Api().get(`/get_custom_fields_to_expected_visit/${this.getCurrentLanguage()}`,{params:{
      ...payload
    }});
  },
  // search for user in entity regardless of site/area/flow
  searchUserInEntity(payload) {
    return Api().get(`search_user_in_entity/${store.getters["authfack/currentEntity"].id}`, {
      params: {
        search: payload,
      },
    });
  },
  getUsersGridData() {
    return Api().get(`/data_users_grid/${store.getters["authfack/currentEntity"].id}`);
  },

  fetchQuickPasses(payload) {
    return Api().post(`/quick-passes`, payload);
  },
};
